import React from 'react';
import { Chip } from 'primereact/chip';

import '../static/styles/Footer.css';

export default function Footer() {
    const date = new Date();
    let year = date.getFullYear();
    return (
        <div className='my-5'>
            <h2 className='title'>Let's Get in Touch</h2>
            <p>Hit me up for work, coffee chats, advice, or let me know your favourite anime/sitcoms</p>
            <div className='card flex flex-wrap gap-2'>
                <a href="https://www.linkedin.com/in/prathameshlakawade" target="_blank" rel="noopener noreferrer">
                    <Chip label="LinkedIn" icon="pi pi-linkedin" className="clickable-chip" />
                </a>
                
                <a href="https://github.com/PrathameshLakawade" target="_blank" rel="noopener noreferrer">
                    <Chip label="GitHub" icon="pi pi-github" className="clickable-chip" />
                </a>

                <a href="https://www.instagram.com/prathameshlakawade" target="_blank" rel="noopener noreferrer">
                    <Chip label="Instagram" icon="pi pi-instagram" className="clickable-chip" />
                </a>

                {/* <a href="https://twitter.com/your-profile" target="_blank" rel="noopener noreferrer">
                    <Chip label="Twitter" icon="pi pi-twitter" className="clickable-chip" />
                </a> */}

                <a href="mailto:prathameshlakawade@gmail.com">
                    <Chip label="Mail" icon="pi pi-envelope" className="clickable-chip" />
                </a>
            </div>
            <p className='p-5 text-center lg:pt-3 lg:px-0 lg:pb-0 lg:text-left gray'>Designed and coded by Prathamesh Lakawade ❤️</p>
            <div className='grid py-0 footer-meta'>
                <div className='col-12 lg:col-6 py-0'>
                    <p className='m-0 console gray text-center lg:text-left'>© Prathamesh Lakawade {year}</p>
                </div>
                <div className='col-12 lg:col-6 py-0'>
                    <p className='m-0 console gray text-center lg:text-right'>Last Updated: October 2025</p>
                </div>
            </div>
        </div>
    );
}
